"use client";
import {
  Image_default
} from "./chunk-KBWHYFNM.mjs";

// src/components/sections/BestExperience/BestExperience.tsx
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var BestExperience = forwardRef(
  function BestExperience2({
    title,
    titleColor = "text-stone-500",
    stamps,
    className = "flex justify-center items-center py-40 lg:py-80 px-24 2xl:px-0 w-full"
  }, ref) {
    return /* @__PURE__ */ jsx("div", { className, ref, children: /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap lg:flex-nowrap gap-16 md:gap-40 justify-center items-center w-full max-w-[455px] md:max-w-7xl", children: [
      /* @__PURE__ */ jsx(
        "h2",
        {
          className: `w-full lg:max-w-[465px] font-display text-xl md:text-2xl font-bold leading-5 lg:leading-6 text-center lg:text-left ${titleColor}`,
          children: title
        }
      ),
      /* @__PURE__ */ jsx("div", { className: "flex md:grid lg:flex flex-col md:flex-row grid-cols-2 gap-16 md:gap-40 lg:gap-16 xl:gap-40 justify-center items-center w-full md:max-w-[383px] lg:max-w-[775px]", children: stamps.map(({ image }) => /* @__PURE__ */ jsx(
        "div",
        {
          className: "w-[179px] md:w-[179px] h-[70px] md:h-[70px]",
          children: /* @__PURE__ */ jsx(
            Image_default,
            {
              src: image.path,
              alt: image.alternativeText,
              className: "object-contain w-full h-full"
            }
          )
        },
        image.alternativeText
      )) })
    ] }) });
  }
);
var BestExperience_default = BestExperience;

export {
  BestExperience_default
};
